(function() {
  window.storeService = {
    get() {
        return axios.get(`/api/store/get.php?twitchId=${utils.cookies.get('user_id')}`);
    },
    save(data) {
        return axios.post('/api/store/save.php', data);
    },
    buy(store){
      store.twitchId = utils.cookies.get('user_id')
        return axios.post('/api/store/save.php', store);
    },
    activateItem(id){
      return axios.post('/api/store/save.php', id);
    },
    uploadImage(id, file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('id', id);
      return axios.post('/api/store/upload.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  }
})();